var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedViewer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.875 17.5h15.833V15H1.875v2.5zm15-10.833H2.708a.836.836 0 0 0-.833.833v5c0 .458.375.833.833.833h14.167a.836.836 0 0 0 .833-.833v-5a.836.836 0 0 0-.833-.833zm-15-4.167V5h15.833V2.5H1.875z"
})));
export default SvgFeedViewer;